import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import PaymentData from "./PaymentData";
import PaymentData1xbet from "./PaymentData1xbet";

function PaymentDataIndex() {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <PaymentData1xbet /> : <PaymentData />;
}

export default PaymentDataIndex;
